import { TableCell, TableRow } from '@hivewatch/dark'

import type { IncidentRowDataType } from '../../types/types'
import type { DarkIncidentColumn } from '../types'

export const IncidentsTableRow = ({
  columns,
  row,
  isSelected,
  onClick,
}: {
  columns: DarkIncidentColumn[]
  row: IncidentRowDataType
  isSelected: boolean
  onClick: (row: IncidentRowDataType) => void
}) => (
  <TableRow isSelected={isSelected} onClick={() => onClick(row)}>
    {columns.map((column) => (
      <TableCell key={column.key} {...column.style}>
        {column.cell(row)}
      </TableCell>
    ))}
  </TableRow>
)
